import React from 'react';
import { Box, Typography, IconButton, Theme } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Edit, FlightTakeoff, FlightLand } from '@material-ui/icons';
import { DateTime } from 'luxon';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      backgroundColor: theme.alert.yellow.extraLight,
      borderRadius: '8px',
      padding: '10px 16px',
      marginTop: '0.9375rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      border: `1px solid ${theme.alert.yellow.light}`,
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    icon: {
      color: theme.alert.yellow.medium,
    },
    text: {
      fontSize: '14px',
      fontWeight: 500,
      color: theme.alert.yellow.dark,
      lineHeight: '1.2',
    },
    dateText: {
      fontSize: '13px',
      color: theme.alert.yellow.medium,
      marginTop: '1px',
      lineHeight: '1.2',
    },
    editButton: {
      padding: '6px',
      color: theme.alert.yellow.medium,
      '&:hover': {
        backgroundColor: theme.alert.yellow.light,
      },
    },
  })
);

interface Props {
  type: 'start' | 'end';
  date: string;
  endDate?: string; // For start cards, show the end date
  onEdit: () => void;
}

export function LeavePeriodCard({ type, date, endDate, onEdit }: Props) {
  const classes = useStyles();

  const formattedDate = DateTime.fromISO(date).toFormat('dd MMM yyyy');
  const formattedEndDate = endDate ? DateTime.fromISO(endDate).toFormat('dd MMM yyyy') : '';

  const isStart = type === 'start';
  const Icon = isStart ? FlightTakeoff : FlightLand;
  const title = isStart ? 'Leave Period Starts' : 'Leave Period Ends';

  return (
    <Box className={classes.card}>
      <Box className={classes.content}>
        <Icon className={classes.icon} />
        <Box>
          <Typography className={classes.text}>{title}</Typography>
          <Typography className={classes.dateText}>
            {isStart && endDate ? `${formattedDate} - ${formattedEndDate}` : formattedDate}
          </Typography>
        </Box>
      </Box>
      <IconButton className={classes.editButton} onClick={onEdit} size='small' title='Edit leave periods'>
        <Edit fontSize='small' />
      </IconButton>
    </Box>
  );
}
